import {ResourceType} from "@/model/ThingModel";

export enum DeviceControlTmplType {
    IN_OUT = "IN_OUT",
    TASK = "TASK",
    REPORT = "REPORT",
}

export class DeviceControl {
    deviceId!: number
    identifier!: string
    args!: {}

    constructor() {
        this.init()
    }

    init(): void {
        this.deviceId = -1
        this.identifier = ''
        this.args = {}
    }
}

export interface DeviceControlTmpl {
    funId: number;
    funName: string;
    resourceType: ResourceType;
    type: DeviceControlTmplType;

    init(): void;
}

export abstract class BaseDeviceControlTmpl implements DeviceControlTmpl {
    funId!: number
    funName!: string
    resourceType!: ResourceType
    type!: DeviceControlTmplType

    abstract init(): void
}

export class DeviceServiceControlTmpl extends BaseDeviceControlTmpl {

    inputControl!: DeviceControl
    outputControl!: DeviceControl

    constructor() {
        super()
        this.init()
    }

    init() {
        this.funId = -1
        this.funName = ''
        this.inputControl = new DeviceControl()
        this.outputControl = new DeviceControl()
    }
}


export class DeviceEventControlTmpl extends BaseDeviceControlTmpl {

    outputControl!: DeviceControl

    constructor() {
        super()
        this.init()
    }

    init() {
        this.funId = -1
        this.funName = ''
        this.outputControl = new DeviceControl()
    }
}